module.exports = __webpack_public_path__ + "img/Market share Icon - charcoal.09068ebe.svg";